import "./form-payment.scss";

import { PaymentFormSchema } from "@factory/form/form.rule";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

type InputFormSchema = PaymentFormSchema;
export function FormPayment() {
  const { control, setValue } = useFormContext<PaymentFormSchema>();
  const { invoiceId } = useParams();
  setValue("voucher", invoiceId);

  const paymentTypes = [
    {
      label: "Downpayment",
      value: "DOWNPAYMENT",
    },
    {
      label: "Full Payment",
      value: "FULLPAYMENT",
    },
    // {
    //   label: "Final Payment",
    //   value: "Final Payment",
    // },
  ];
  return (
    <div id="FormPayment" className="payment">
      {/* <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      /> */}
      <DropdownControl<InputFormSchema>
        control={control}
        name="paymentType"
        label="Payment Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter paymentType"
        options={paymentTypes}
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="paymentDate"
        label="Payment Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
    </div>
  );
}

export default FormPayment;
